import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_2 = { class: "mb-8 text-lg font-semibold leading-7.5" }

import { store } from "@/state/store";
import SharedButton from "@SharedVueComponents/SharedButton.vue";
import { switchLoginAndRegister } from "@/services/sharedFunctions";

export default /*#__PURE__*/_defineComponent({
  __name: 'BottomLoginRegisterToggle',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(store).isModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t(_unref(store).isLogin ? "login.switch_headline" : "registration.switch_headline")), 1),
        _createVNode(SharedButton, {
          variant: "secondary",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(switchLoginAndRegister)('Bottom')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(_unref(store).isLogin ? "login.switch_action" : "registration.switch_action")), 1)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})